import { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { JackpotOptions } from "../components/jackpot-component";
import { JackpotTriggertrailResult } from "../integration/model/results/jackpot-triggertrail-result";
import { JackpotTiers } from "../names";

export default class JackpotValuesControl extends AbstractControl implements Control {

    protected static jackpotOptions: JackpotOptions;

    protected assetName: string;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: SmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.assetName = assetName;

        if (JackpotValuesControl.jackpotOptions) {
            return;
        }

        const initRecord = GameState.getCurrentGame().getRootRecord();
        const jackpotResult = initRecord.getResultsOfType(JackpotTriggertrailResult)[0];
        JackpotValuesControl.jackpotOptions = new JackpotOptions(jackpotResult.jackpots[3], jackpotResult.jackpots[2], jackpotResult.jackpots[1], jackpotResult.jackpots[0]);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        const creditSize = options.creditSizes.currentValue;

        this.layer.refreshBitmapCache();
        this.setJackpotAmount(JackpotTiers.MINI, JackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MINI) * creditSize);
        this.setJackpotAmount(JackpotTiers.MINOR, JackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MINOR) * creditSize);
        this.setJackpotAmount(JackpotTiers.GRAND, JackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.GRAND) * creditSize);
        this.setJackpotAmount(JackpotTiers.MAJOR, JackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MAJOR) * creditSize);
    }

    protected setJackpotAmount(jackpot: JackpotTiers, amount: number) {
        this.layer.getText(this.assetName + jackpot + "_" + Orientation.PORTRAIT.toString()).text = Services.currency.format(amount, false, false);
        this.layer.getText(this.assetName + jackpot + "_" + Orientation.LANDSCAPE.toString()).text = Services.currency.format(amount, false, false);
    }
}
